import { Checkbox } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useRecurringInvoiceForm } from '../../../../../../../../contexts/recurringInvoiceFormContext'

export const DeliveryNotification = () => {
  const { t } = useTranslation()
  const { recurringInvoiceForm } = useRecurringInvoiceForm()
  const { FormItem } = recurringInvoiceForm

  return (
    <FormItem
      name="deliveryNotification"
      render={({ field: { value, ...props } }) => (
        <Checkbox {...props} checked={value}>
          {t('external_invoices.editor.form.recurring_invoice_settings.field.delivery_notification.label')}
        </Checkbox>
      )}
    />
  )
}
